import { render, staticRenderFns } from "./UserDataTable.vue?vue&type=template&id=ca046aee"
import script from "./UserDataTable.vue?vue&type=script&lang=js"
export * from "./UserDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports